import { render, staticRenderFns } from "./ElementAudio.vue?vue&type=template&id=8c434d0a"
import script from "./ElementAudio.vue?vue&type=script&lang=js"
export * from "./ElementAudio.vue?vue&type=script&lang=js"
import style0 from "./ElementAudio.vue?vue&type=style&index=0&id=8c434d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports